import { render } from "./LogoutView.vue?vue&type=template&id=5db80e66"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SebastiánContreras\\OneDrive - Defensoría del Contribuyente\\Documents\\INGENIERIA DESARROLLO_TI\\REPOSITORIO_PROYECTOS\\AUTENTIFICACION_FRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__